import React from "react";
import { DashboardRenderSalesforceEntity } from "../dashboard-render-salesforce-entity/dashboard-render-salesforce-entity";

export function PostmatchTableRenderSalesforce() {
  return function (link: string) {
    return <DashboardRenderSalesforceEntity link={link} />;
  };
}
